// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 3H2V11H22V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13H2V21H22V13Z"}}]};

const ComponentSpaceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-space-filled',
    ref,
    icon: element,
  },
));

ComponentSpaceFilledIcon.displayName = 'ComponentSpaceFilledIcon';

export default ComponentSpaceFilledIcon;
